// Типы состояний и данных

export interface OrdersState {
  isLoading: {
    list: boolean;
    single: boolean;
    create: boolean;
    delete: boolean;
    commit: boolean;
    addItems: boolean;
    updateItem: boolean;
    deleteItem: boolean;
  };
  errors: {
    list: string | null;
    single: string | null;
    create: string | null;
    delete: string | null;
    commit: string | null;
    addItems: string | null;
    updateItem: string | null;
    deleteItem: string | null;
  };
  list: OrderDTO[] | null;
  currentOrder: OrderDTO | null;
}

export interface OrderDTO {
  status: number;
  number: number;
  pk: string;
  is_active: boolean;
  created_at: string;
  order_items: OrderItemDTO[];
  user_id: string;
}

export interface OrderItemDTO {
  good_name: string;
  good_description: string;
  comment: string;
  amount: number;
  price: number;
  delivery_term: number;
  pk: string;
  is_active: boolean;
}

// Константы для экшенов

// Список заказов
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE';

// Получение заказа по ID
export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_FAILURE = 'GET_ORDER_FAILURE';

// Создание заказа
export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

// Удаление заказа
export const DELETE_ORDER_REQUEST = 'DELETE_ORDER_REQUEST';
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_FAILURE = 'DELETE_ORDER_FAILURE';

// Коммит заказа
export const COMMIT_ORDER_REQUEST = 'COMMIT_ORDER_REQUEST';
export const COMMIT_ORDER_SUCCESS = 'COMMIT_ORDER_SUCCESS';
export const COMMIT_ORDER_FAILURE = 'COMMIT_ORDER_FAILURE';

// Добавление товаров в заказ
export const ADD_ITEMS_REQUEST = 'ADD_ITEMS_REQUEST';
export const ADD_ITEMS_SUCCESS = 'ADD_ITEMS_SUCCESS';
export const ADD_ITEMS_FAILURE = 'ADD_ITEMS_FAILURE';

// Получение товара по ID
export const GET_ORDER_ITEM_REQUEST = 'GET_ORDER_ITEM_REQUEST';
export const GET_ORDER_ITEM_SUCCESS = 'GET_ORDER_ITEM_SUCCESS';
export const GET_ORDER_ITEM_FAILURE = 'GET_ORDER_ITEM_FAILURE';

// Обновление товара в заказе
export const UPDATE_ORDER_ITEM_REQUEST = 'UPDATE_ORDER_ITEM_REQUEST';
export const UPDATE_ORDER_ITEM_SUCCESS = 'UPDATE_ORDER_ITEM_SUCCESS';
export const UPDATE_ORDER_ITEM_FAILURE = 'UPDATE_ORDER_ITEM_FAILURE';

// Удаление товара из заказа
export const DELETE_ORDER_ITEM_REQUEST = 'DELETE_ORDER_ITEM_REQUEST';
export const DELETE_ORDER_ITEM_SUCCESS = 'DELETE_ORDER_ITEM_SUCCESS';
export const DELETE_ORDER_ITEM_FAILURE = 'DELETE_ORDER_ITEM_FAILURE';
